import { defineComponent, SVGAttributes } from "vue";

  export const SvgMoon = defineComponent<SVGAttributes>({
    setup() {
      return () => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8.40579 14.6136a6.63705 6.63705 0 1 1 .33887-13.2656l.86279.0459-.46972.72461a5.39015 5.39015 0 0 0 -.49366.98144 5.6456 5.6456 0 0 0 3.22609 7.293 5.71022 5.71022 0 0 0 1.75.376l.85058.04687-.45507.71973a6.63834 6.63834 0 0 1 -5.60988 3.07805zm-.53613-12.251a5.6392 5.6392 0 1 0 4.813 9.2969 6.6449 6.6449 0 0 1 -4.9712-8.92093c.04979-.12789.10256-.25387.15819-.37594z"/></svg>;
    },
  });